import './chunk-2452e3d3.js';
import './helpers.js';
import './chunk-8ed29c41.js';
import './chunk-75a5af93.js';
import './chunk-d92f0cd9.js';
import { r as registerComponent, u as use } from './chunk-cca88db8.js';
import './chunk-ae8ab23a.js';
import './chunk-29ca0df8.js';
import './chunk-ece062a7.js';
import './chunk-42f463e6.js';
import './chunk-4b67a181.js';
import './chunk-b07e3182.js';
import './chunk-83eb0d37.js';
import { T as Timepicker } from './chunk-21fc0948.js';
export { T as BTimepicker } from './chunk-21fc0948.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Timepicker);
  }
};
use(Plugin);

export default Plugin;



//////////////////
// WEBPACK FOOTER
// ./node_modules/buefy/dist/esm/timepicker.js
// module id = null
// module chunks = 